import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';

export const getEmailTemplate = createAsyncThunk('editorSlice/getEmailTemplate', async () => {
    try {
        let response = await axios.get('/email-template', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmailTemplateById = createAsyncThunk('editorSlice/getEmailTemplateById', async (id) => {
    try {
        let response = await axios.get('/email-template/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmailTemplateByCategory = createAsyncThunk('editorSlice/getEmailTemplateByCategory', async (id) => {
    try {
        let response = await axios.get(`/email-template?categoryId=${id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmailTemplateOption = createAsyncThunk('editorSlice/getEmailTemplateOption', async () => {
    try {
        let response = await axios.get('/email-template/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmailTemplateCategoryOption = createAsyncThunk('editorSlice/getEmailTemplateCategoryOption', async () => {
    try {
        let response = await axios.get('/email-template-category/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createEmailTemplate = createAsyncThunk('editorSlice/createEmailTemplate', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/email-template', data, {
            headers: {
                'Content-Type': 'application/json'
            }
            //loader: false
        });
        toast.success(response?.data?.message || 'Email Template Created successfully.');
        dispatch(getEmailTemplate());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const updateEmailTemplate = createAsyncThunk('editorSlice/updateEmailTemplate', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/email-template/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
            //loader: false
        });
        toast.success(response?.data?.message || 'Email Template updated successfully.');
        await dispatch(getEmailTemplate());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const updateEmailTemplateStatus = createAsyncThunk('editorSlice/updateEmailTemplateStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/email-template/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully !');
        dispatch(getEmailTemplate());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});
export const deleteEmailTemplate = createAsyncThunk('editorSlice/deleteEmailTemplate', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/email-template/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Email Template deleted successfully.');
        await dispatch(getEmailTemplate());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const createEmailCategory = createAsyncThunk('editorSlice/createEmailCategory', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/email-template-category', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Email Template Category added successfully.');
        dispatch(getEmailTemplate());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const updateEmailCategory = createAsyncThunk('editorSlice/createEmailCategory', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/email-template-category/' + data.id, data.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Email Template Category update successfully.');
        dispatch(getEmailTemplateCategoryOption());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});
export const deleteEmailCategory = createAsyncThunk('editorSlice/deleteEmailCategory', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/email-template-category/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
            //loader: false
        });
        toast.success(response?.data?.message || 'Email Template Category deleted successfully.');
        await dispatch(getEmailTemplateCategoryOption());

        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const getEmailImages = createAsyncThunk('editorSlice/getEmailImages', async () => {
    try {
        let response = await axios.get('/email-images', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const addEmailImage = createAsyncThunk('editorSlice/addEmailImage', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/email-images', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // toast.success(response?.data?.message || 'Email Image added successfully.');
        dispatch(getEmailImages());
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteEmailImage = createAsyncThunk('editorSlice/deleteEmailImage', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/email-images/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
            // loader: false
        });
        toast.success(response?.data?.message || 'Email Image deleted successfully.');
        dispatch(getEmailImages());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const getEmailImageById = createAsyncThunk('editorSlice/getEmailImageById', async (id) => {
    try {
        let response = await axios.get('/email-images/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const editorSlice = createSlice({
    name: 'editorSlice',
    initialState: {
        data: [],
        option: [],
        categoryOption: [],
        selectedData: {},
        selectedCategory: [],
        imageData: [],
        selectedImage: {}
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEmailTemplate.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getEmailTemplateOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
        builder.addCase(getEmailTemplateCategoryOption.fulfilled, (state, action) => {
            state.categoryOption = action.payload;
            return;
        });
        builder.addCase(getEmailTemplateById.fulfilled, (state, action) => {
            state.selectedData = action.payload;
            return;
        });
        builder.addCase(getEmailTemplateByCategory.fulfilled, (state, action) => {
            state.selectedCategory = action.payload;
            return;
        });
        builder.addCase(getEmailImages.fulfilled, (state, action) => {
            state.imageData = action.payload;
            return;
        });
        builder.addCase(getEmailImageById.fulfilled, (state, action) => {
            state.selectedImage = action.payload;
            return;
        });
    }
});

export default editorSlice.reducer;
